import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import { useTheme } from '../context/ThemeContext';

const Layout = () => {
  const { isDarkMode, isCompactMode } = useTheme();
  const location = useLocation();
  const usesWorkspaceScroll = [
    '/user/settings',
    '/admin/configuration',
  ].some((route) => location.pathname.startsWith(route));
  
  return (
    <div className={`app-shell ${isDarkMode ? 'dark' : ''} ${isCompactMode ? 'compact' : ''}`}>
      <Sidebar />
      <div className="workspace-column">
        <main
          className={`app-workspace ${usesWorkspaceScroll ? 'app-workspace--page-scroll' : ''}`}
          id="main-content"
          tabIndex="-1"
        >
          <div className="app-workspace__frame">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
